import React, { useMemo } from "react";
import "./Avatar.scss";
import ClassNames from "classnames";

export type AvatarSize = "xs" | "s" | "m";

export interface AvatarProps {
  name?: string;
  disabled?: boolean;
  size?: AvatarSize;
  showTitle?: boolean;
}

const Avatar: React.FC<AvatarProps> = ({
  name,
  disabled = false,
  size = "m",
  showTitle = true,
}) => {
  const stringToHslColor = (
    str: string | undefined,
    a: number,
    s = 30,
    l = 60
  ) => {
    let hash = 0;
    for (let i = 0; i < (str?.length as number); i++) {
      hash = str!.charCodeAt(i) + ((hash << 5) - hash);
    }

    let h = hash % 360;
    return "hsl(" + h + ", " + s + "%, " + l + "%, " + a + "%)";
  };

  const initials = useMemo(() => {
    const nameArr = name?.split(" ");

    if (nameArr?.length === 1 || !nameArr?.[1]) {
      const newArray = nameArr![0].substring(
        0,
        nameArr![0]?.[1] === "@" ? 1 : 2
      );
      return nameArr![0]?.[1] === "@" ? newArray : newArray?.toUpperCase();
    }

    return `${nameArr?.[0]?.substring(0, 1)?.toUpperCase()}${nameArr?.[1]
      ?.substring(0, 1)
      ?.toUpperCase()}`;
  }, [name]);

  const bgColor = useMemo(() => {
    return stringToHslColor(initials?.toLowerCase(), 15);
  }, [initials]);

  const borderColor = useMemo(() => {
    return stringToHslColor(initials?.toLowerCase(), 100);
  }, [initials]);

  const classNameWrapper = ClassNames("user-avatar", {
    "is-small": size === "s",
    "is-xs": size === "xs",
    "is-medium": size === "m",
  });

  return (
    <div
      className={classNameWrapper}
      title={showTitle ? name : undefined}
      style={{
        backgroundColor: !disabled ? bgColor : "var(--main-background-color)",
        borderColor: !disabled ? borderColor : "var(--border-color-soft)",
        color: !disabled ? borderColor : "var(--text-color-disabled)",
      }}
    >
      <span>{initials}</span>
    </div>
  );
};

export default Avatar;
